'use strict';

export  class Banner {
  constructor() {
    this.name = 'banner';
    $("#play-video").on("click", function(){
      //$('.ct-banner__inner.ct-background--normal').css('background-image','none');
      //$('.ct-banner__inner.ct-background--normal .container').append('<div class="video-wrapper"><video autoplay loop muted><source src="https://bcast.siteinprod.com.au/themes/custom/bcast/images/Demo-BCAST-compressed.mp4" type="video/mp4"></video></div>');
    })
  }
}
